module.exports = __webpack_public_path__ + "static/media/profile.def47aac.png";